//Formik
import { useField } from "formik"

//PrimeReact
import { InputText } from "primereact/inputtext"
import { InputSwitch } from "primereact/inputswitch"

//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"
import assessStyles from "../../../../../styles/assessments/Assessment.module.css"
import { Button } from "primereact/button"
import { classNames } from "primereact/utils"

export default function FormTitlePanel({
  preview,
  onPreviewChange,
  onShowScoreCalculation,
  disabled,
}) {
  const [title, , titleHelpers] = useField("assessment.title")

  return (
    <div
      className={classNames(myStyles.formTitleContainer, {
        [myStyles.formTitleContainerPreviewLayout]: preview,
      })}
    >
      <div className={myStyles.formTitleContainerTitle}>
        {!preview ? (
          <InputText
            value={title.value}
            onChange={(e) => {
              titleHelpers.setValue(e.target.value)
            }}
            className={myStyles.formTitleContainerTitleInput}
            placeholder="No title specified"
            disabled={disabled}
          />
        ) : (
          <label className={myStyles.formTitleContainerTitleLabel}>
            {title.value}
          </label>
        )}
      </div>
      {!preview && (
        <div className={classNames(myStyles.formTitleContainerScoreCalc)}>
          <Button
            type="button"
            onClick={onShowScoreCalculation}
            disabled={disabled || preview}
          >
            <span className={`material-icons`}>{"calculate"}</span>
            Edit form formula
          </Button>
        </div>
      )}
      <div
        className={`${myStyles.formTitleContainerPreview} ${assessStyles.switchControl}`}
      >
        Preview form
        <InputSwitch
          checked={preview}
          onChange={(e) => {
            onPreviewChange(e.value)
          }}
        />
      </div>
    </div>
  )
}
